import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

export const HelmetBlock = () => {
  const { pathname } = useLocation();

  const metInfo = useMemo(() => {
    return pageList.find((x) => x.pathname === pathname);
  }, [pathname]);

  return (
    <Helmet async key={`${createTimestamp()}-${metInfo?.pathname ?? ''}`}>
      <title>{metInfo?.title ?? '飲食店開業・経営支援サイト|オミセクラフト'}</title>
    </Helmet>
  );
};

const pageList = [
  { pathname: '/', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/about', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  {
    pathname: '/balance_simulation',
    title: '飲食店開業損益シミュレーション・資金計画 | オミセクラフト'
  },
  {
    pathname: '/balance_simulation/complete',
    title: '飲食店開業・経営支援サイト|オミセクラフト'
  },
  { pathname: '/contact', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/contact/confirm', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/contact/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/design', title: '飲食店施工実績が豊富な内装会社マッチング｜オミセクラフト' },
  { pathname: '/design/contact', title: '飲食店施工実績が豊富な内装会社マッチング｜オミセクラフト' },
  { pathname: '/error', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/faq', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/favorite_properties', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/forgot_password', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/login', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/concept', title: '飲食店開業コンセプト設計・作り方ガイド | オミセクラフト' },
  { pathname: '/mypage/concept/complete', title: '飲食店開業コンセプト設計・作り方ガイド | オミセクラフト' },
  { pathname: '/mypage/email/change', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/email/change/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/leave', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/leave/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/leave/confirm', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/member/', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/member/change', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/member/change/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/password', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/password/change', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/mypage/password/change/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/news', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/property', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/property/create', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/login', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/members', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/mypage', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/ope/two_auth', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/partner', title: '飲食店開業・経営支援・スポットコンサルティング|オミセクラフト' },
  { pathname: '/privacy', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/properties/municipalities', title: '飲食店向け貸店舗・空き店舗・居抜き物件検索|オミセクラフト' },
  { pathname: '/properties/prefectures', title: '飲食店向け貸店舗・空き店舗・居抜き物件検索|オミセクラフト' },
  { pathname: '/properties/route', title: '飲食店向け貸店舗・空き店舗・居抜き物件検索|オミセクラフト' },
  { pathname: '/properties/stations', title: '飲食店向け貸店舗・空き店舗・居抜き物件検索|オミセクラフト' },
  { pathname: '/property', title: '飲食店向け貸店舗・空き店舗・居抜き物件検索|オミセクラフト' },
  { pathname: '/regist/member_info', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/regist/complete', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/regist/confirm', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/regist/email_verify', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/regist/email_verify_temp', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/term', title: '飲食店開業・経営支援サイト|オミセクラフト' },
  { pathname: '/todo', title: '飲食店開業までの流れ・チェックリスト | オミセクラフト' }
];

function createTimestamp() {
  const unixTimestamp = Math.floor(Date.now() / 1000);
  const formattedTimestamp = moment(unixTimestamp * 1000).format('YYYYMMDDHHmmssSSS');
  return formattedTimestamp;
}
